import "./yakubato-lp.38d24a21.js";


function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiree9d4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiree9d4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8lgcy", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $d139b46541d1dd2f$export$2e2bcd8739ae039);

var $3cJ3M = parcelRequire("3cJ3M");

var $1QKbB = parcelRequire("1QKbB");

var $ddRa2 = parcelRequire("ddRa2");

var $cPz9N = parcelRequire("cPz9N");
const $d139b46541d1dd2f$var$ROW_COUNT = 3;
var $d139b46541d1dd2f$export$2e2bcd8739ae039 = (0, $3cJ3M.defineComponent)({
    setup () {
        const loading = (0, $3cJ3M.ref)(false);
        const store = (0, $1QKbB.useStore)();
        let cleanupSlider = null;
        let isUnmounted = false;
        (0, $3cJ3M.onBeforeMount)(async ()=>{
            loading.value = true;
            const response = await store.fetchMedicalInstitutions();
            if (isUnmounted) return;
            if (response) {
                loading.value = false;
                await (0, $3cJ3M.nextTick)();
                cleanupSlider = (0, $ddRa2.slider)({
                    slideSpeed: (0, $ddRa2.DEFAULT_SLIDE_SPEED) / 2
                });
            }
        });
        (0, $3cJ3M.onBeforeUnmount)(()=>{
            isUnmounted = true;
            if (cleanupSlider) cleanupSlider();
        });
        const sliderColumns = (0, $3cJ3M.computed)(()=>(0, $cPz9N.splitIntoColumns)(store.medicalInstitutions, $d139b46541d1dd2f$var$ROW_COUNT));
        return {
            loading: loading,
            sliderColumns: sliderColumns
        };
    }
});

});
parcelRegister("1QKbB", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $1705b9f5a2a9abf9$export$6ccbb43953eebf8);

var $97VdX = parcelRequire("97VdX");
const $1705b9f5a2a9abf9$export$6ccbb43953eebf8 = (0, $97VdX.defineStore)('index', {
    state: ()=>({
            medicalInstitutions: []
        }),
    actions: {
        async fetchMedicalInstitutions () {
            try {
                const response = await this.$api.topApi.getTop();
                this.medicalInstitutions = response.data.medicalInstitutions;
                return true;
            } catch  {
                return false;
            }
        }
    }
});

});

parcelRegister("ddRa2", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_SLIDE_SPEED", () => $191f68a9e115f36c$export$662bf3778ef943f5);
$parcel$export(module.exports, "slider", () => $191f68a9e115f36c$export$b38bf4f33e9e4c25);
// ループスライダー
const $191f68a9e115f36c$export$662bf3778ef943f5 = 6700;
const $191f68a9e115f36c$var$LIST_ITEM_MARGIN = 24;
function $191f68a9e115f36c$export$b38bf4f33e9e4c25(options) {
    const { slideSpeed: slideSpeed = $191f68a9e115f36c$export$662bf3778ef943f5 } = options ?? {};
    const sliderEl = document.querySelector('.adopt-slider');
    const sliderWrap = document.querySelector('.adopt-slider .adopt-slider-wrap');
    const sliderList = document.querySelector('.adopt-slider-list');
    const sliderListItem = document.querySelector('.adopt-slider-list > li');
    if (!sliderEl || !sliderWrap || !sliderList || !sliderListItem) return function cleanup() {};
    let currentAnimation = null;
    let savedPosition = 0;
    const listItemCount = sliderList.childElementCount;
    const listItemWidth = sliderListItem.clientWidth;
    const listItemHeight = sliderListItem.clientHeight;
    const listWidth = listItemWidth * listItemCount + $191f68a9e115f36c$var$LIST_ITEM_MARGIN * listItemCount;
    if (listItemCount === 0 || listWidth <= 0) return function cleanup() {};
    sliderEl.style.height = `${listItemHeight}px`;
    sliderList.style.width = `${listWidth}px`;
    /**
   * 必要な数のスライダークローンを動的に作成・調整する
   */ function createClones(cloneCount) {
        const existingClones = sliderWrap.querySelectorAll('.adopt-slider-list.slider-clone');
        const currentCloneCount = existingClones.length;
        if (currentCloneCount === cloneCount) return;
        if (currentCloneCount > cloneCount) for(let i = cloneCount; i < currentCloneCount; i++)existingClones[i].remove();
        else {
            const additionalCloneCount = cloneCount - currentCloneCount;
            for(let i = 0; i < additionalCloneCount; i++){
                const sliderListClone = sliderList.cloneNode(true);
                sliderListClone.classList.add('slider-clone');
                sliderWrap.appendChild(sliderListClone);
            }
        }
    }
    /**
   * 現在実行中のスライダーアニメーションを停止する
   */ function stopAnimation() {
        if (currentAnimation && sliderWrap) {
            const computedStyle = window.getComputedStyle(sliderWrap);
            const currentLeft = parseInt(computedStyle.left, 10) || 0;
            savedPosition = currentLeft;
            currentAnimation.onfinish = null;
            currentAnimation.cancel();
            currentAnimation = null;
        }
    }
    /**
   * スライダーの位置アニメーションを実行する
   */ function sliderPosition() {
        const fromPosition = savedPosition;
        const moveDistance = Math.abs(-listWidth - fromPosition);
        const adjustedDuration = Math.floor(moveDistance / listWidth * (slideSpeed * listItemCount));
        currentAnimation = sliderWrap.animate({
            left: [
                `${fromPosition}px`,
                `-${listWidth}px`
            ]
        }, {
            duration: adjustedDuration,
            easing: 'linear',
            fill: 'forwards'
        });
        currentAnimation.onfinish = ()=>{
            savedPosition = 0;
            sliderWrap.style.left = '0px';
            sliderPosition();
        };
    }
    /**
   * スライダーを初期化
   */ function initializeSlider() {
        if (!sliderEl || !sliderWrap || !sliderList) return;
        stopAnimation();
        const requiredCloneCount = Math.ceil(sliderEl.clientWidth / listWidth);
        createClones(requiredCloneCount);
        const totalWidth = listWidth * (requiredCloneCount + 1);
        sliderWrap.style.width = `${totalWidth}px`;
        if (savedPosition === 0) sliderWrap.style.left = '0px';
        else sliderWrap.style.left = `${savedPosition}px`;
        sliderPosition();
    }
    let debounceTimeoutId = null;
    function handleResize() {
        if (debounceTimeoutId) clearTimeout(debounceTimeoutId);
        debounceTimeoutId = window.setTimeout(()=>{
            initializeSlider();
        }, 300);
    }
    window.addEventListener('resize', handleResize);
    initializeSlider();
    return function cleanup() {
        window.removeEventListener('resize', handleResize);
        if (debounceTimeoutId) clearTimeout(debounceTimeoutId);
        stopAnimation();
    };
}

});

parcelRegister("cPz9N", function(module, exports) {

$parcel$export(module.exports, "splitIntoColumns", () => $152fd9673f8339e4$export$fce9552fd48ddf8e);
/**
 * 配列を列ベースで分割する
 * 各列に rowCount 個のアイテムが縦に並ぶ形で分割
 * 足りない列は先頭のアイテムから補充する
 */ function $152fd9673f8339e4$export$fce9552fd48ddf8e(items, rowCount) {
    const safeRowCount = Math.max(rowCount, 1);
    const columnCount = Math.ceil(items.length / safeRowCount);
    const columns = [];
    let fillIndex = 0;
    for(let col = 0; col < columnCount; col++){
        const column = [];
        for(let row = 0; row < safeRowCount; row++){
            const index = row * columnCount + col;
            if (index < items.length) column.push(items[index]);
            else {
                column.push(items[fillIndex % items.length]);
                fillIndex++;
            }
        }
        columns.push(column);
    }
    return columns;
}

});


parcelRegister("aO79z", function(module, exports) {

$parcel$export(module.exports, "render", () => $7de41f6d36bff06a$export$b3890eb0ae9dca99);

var $3cJ3M = parcelRequire("3cJ3M");
const $7de41f6d36bff06a$var$_hoisted_1 = {
    key: 0,
    class: "section-adopt",
    "data-testid": "wrapper"
};
const $7de41f6d36bff06a$var$_hoisted_2 = {
    class: "adopt-slider"
};
const $7de41f6d36bff06a$var$_hoisted_3 = {
    class: "adopt-slider-wrap"
};
const $7de41f6d36bff06a$var$_hoisted_4 = {
    class: "adopt-slider-list"
};
const $7de41f6d36bff06a$var$_hoisted_5 = [
    "src",
    "alt"
];
function $7de41f6d36bff06a$export$b3890eb0ae9dca99(_ctx, _cache, $props, $setup, $data, $options) {
    return !_ctx.loading ? ((0, $3cJ3M.openBlock)(), (0, $3cJ3M.createElementBlock)("section", $7de41f6d36bff06a$var$_hoisted_1, [
        _cache[0] || (_cache[0] = (0, $3cJ3M.createElementVNode)("h2", {
            class: "adopt-title"
        }, "\u5168\u56FD\u306E\u533B\u7642\u6A5F\u95A2\u3067\u63A1\u7528\u3055\u308C\u3066\u3044\u307E\u3059", -1)),
        (0, $3cJ3M.createElementVNode)("div", $7de41f6d36bff06a$var$_hoisted_2, [
            (0, $3cJ3M.createElementVNode)("div", $7de41f6d36bff06a$var$_hoisted_3, [
                (0, $3cJ3M.createElementVNode)("ul", $7de41f6d36bff06a$var$_hoisted_4, [
                    ((0, $3cJ3M.openBlock)(true), (0, $3cJ3M.createElementBlock)((0, $3cJ3M.Fragment), null, (0, $3cJ3M.renderList)(_ctx.sliderColumns, (column, columnIndex)=>{
                        return (0, $3cJ3M.openBlock)(), (0, $3cJ3M.createElementBlock)("li", {
                            key: columnIndex,
                            class: "slider-item"
                        }, [
                            ((0, $3cJ3M.openBlock)(true), (0, $3cJ3M.createElementBlock)((0, $3cJ3M.Fragment), null, (0, $3cJ3M.renderList)(column, (medicalInstitution, rowIndex)=>{
                                return (0, $3cJ3M.openBlock)(), (0, $3cJ3M.createElementBlock)("figure", {
                                    key: `${medicalInstitution.slug}-${rowIndex}`,
                                    class: "slider-item-img"
                                }, [
                                    (0, $3cJ3M.createElementVNode)("img", {
                                        src: medicalInstitution.lpLogoImageUrl,
                                        alt: medicalInstitution.name
                                    }, null, 8, $7de41f6d36bff06a$var$_hoisted_5)
                                ]);
                            }), 128))
                        ]);
                    }), 128))
                ])
            ])
        ])
    ])) : (0, $3cJ3M.createCommentVNode)("", true);
}

});

parcelRegister("52X4H", function(module, exports) {

$parcel$export(module.exports, "default", () => $3acaf6ab42581f76$export$2e2bcd8739ae039);
let $3acaf6ab42581f76$var$NOOP = ()=>{};
var $3acaf6ab42581f76$export$2e2bcd8739ae039 = (script)=>{};

});


var $dZO8a = parcelRequire("dZO8a");
let $ad588ce6c26ce861$var$script;




let $ad588ce6c26ce861$var$initialize = ()=>{
    $ad588ce6c26ce861$var$script = (parcelRequire("8lgcy"));
    if ($ad588ce6c26ce861$var$script.__esModule) $ad588ce6c26ce861$var$script = $ad588ce6c26ce861$var$script.default;
    $ad588ce6c26ce861$var$script.render = (parcelRequire("aO79z")).render;
    $ad588ce6c26ce861$var$script.__cssModules = {};
    (parcelRequire("52X4H")).default($ad588ce6c26ce861$var$script);
    $ad588ce6c26ce861$var$script.__scopeId = 'data-v-590843';
    $ad588ce6c26ce861$var$script.__file = "TopMedicalInstitutionLogoSlider.vue";
};
$ad588ce6c26ce861$var$initialize();
var $ad588ce6c26ce861$export$2e2bcd8739ae039 = $ad588ce6c26ce861$var$script;


(0, $dZO8a.default)((0, $ad588ce6c26ce861$export$2e2bcd8739ae039)).mount('[data-vue="slider"]');


//# sourceMappingURL=yakubato-lp.ce3392b3.js.map
